import { Card } from './card';

export class SearchResultPage {
  constructor(public cards: Card[]) {}
}
